import { Card, Grid, Typography, CardContent, Checkbox } from '@material-ui/core';
import React from 'react';
import classes from '../../../pages/crossDoc/index.module.scss'

function OrderInfo(props: any) {
    const {
        children,
        setCod,
        deliveryLocationType,
        setDeliveryLocationType,
        editMode
    } = props

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContentOrder}>
                <Grid container alignItems="stretch" justifyContent='space-between' spacing={3}>
                    {children}
                </Grid>
                <Grid container spacing={1}>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        lg={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={deliveryLocationType}
                                    // disabled={editMode}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setCod(false)
                                        }
                                        setDeliveryLocationType(e.target.checked);
                                    }}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                    data-cy="fulfillmentServiceCheckBox"
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    // color: editMode ? "#adadad" : "initial"
                                }}
                            >
                                <span>تحویل درب انبار </span>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default OrderInfo;